
import styled from '../../utils/style/styled';
import { BIGGER_SPACING } from './Colors';
import { Iphone11ScreenSize } from '../config';
import { PADDING_HORIZONTAL_MODAL } from './Layout';
import { Pressable } from 'react-native';
import { RFValue } from 'react-native-responsive-fontsize';
import { TextProps } from 'react-native';

export const commonStyles: {label: TextProps,
   greyLabel: any, loading: any, itemContainer: any, centeredView: any,
   modalView: any} = {
     label: {
       fontSize: RFValue(12, Iphone11ScreenSize),
       textTransform: 'uppercase',
       marginLeft: BIGGER_SPACING,
       color: '#787878',
     },
     greyLabel: {
       color: '#787878',
     },
     loading: {
       flexDirection: 'row',
       alignItems: 'center',
       justifyContent: 'center',
       marginTop: 30,
     },
     itemContainer: {
       shadowColor: '#000',
       shadowOffset: {
         width: 0,
         height: 3,
       },
       shadowOpacity: 0.27,
       shadowRadius: 4.65,
       elevation: 6,
     },
     centeredView: {
       justifyContent: 'center',
       alignItems: 'center',
       backgroundColor: 'rgba(0,0,0,0.6)',
       zIndex:1,
       flex:1
     },
     modalView: {
       margin: 20,
       backgroundColor: 'white',
       borderRadius: 10,
       paddingTop: 30,
       paddingHorizontal: PADDING_HORIZONTAL_MODAL,
       paddingBottom:10,
       shadowColor: '#000',
       shadowOffset: {
         width: 0,
         height: 2,
       },
       shadowOpacity: 0.25,
       shadowRadius: 3.84,
       elevation: 5,
       alignItems:'center',
       justifyContent:'center',
     },
   };



export const Container = styled.View`
  flex: 1;
  align-items: center;
  justify-content: center;
`;

// Pressable, NOT TouchableWithoutFeedback. TWF renders no view of its own -- it
// CLONES its child -- so these styles never applied, and the clone is what makes
// React 19 warn "Accessing element.ref was removed" whenever the child carries a
// ref. Pressable renders a real view, so the styles now take effect and there is
// no cloneElement in the path.
export const CheckButton = styled(Pressable)`
  flex-direction: row;
  align-items: center;
`;

export const CheckButtonContainer = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const SafeView = styled.SafeAreaView`
  flex: 1;
  background-color: #fff;
  align-items: center;
`;



export const InputContainer = styled.View`
  justify-content: center;
  margin-top: 50px;
  width: 80%;
`;



